import axios from 'axios'
import { Message } from 'element-ui' // 如果使用 Element UI
import router from '../router/index'
import Vue from 'vue'
let loadingInstance = null
let requestCount = 0

function showLoading () {
  if (requestCount === 0) {
    loadingInstance = Vue.prototype.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    })
  }
  requestCount++
}

function hideLoading () {
  requestCount--
  if (requestCount === 0 && loadingInstance) {
    loadingInstance.close()
  }
}

// 创建 axios 实例
const service = axios.create({
  // 基础 URL
  baseURL: '/api',

  // 超时时间
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    showLoading()
    // 在发送请求前做些什么

    const token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    // 处理请求错误
    console.error('request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    hideLoading()
    const res = response.data
    // console.log(response)
    // 根据后端返回的状态码处理
    if (response.status !== 200 && response.status !== 302) {
      // 错误消息提示
      Message.error(res.message || '请求错误')
      // if (response.path === '/login') {
      //   router.push('/login')
      // }
      return Promise.reject(new Error(res.message || 'Error'))
    } else if (response.status === 200) {
      if (response.data.data === 'redirect') {
        router.push({
          path: '/login',
          query: {
            message: ''
          }
        })
      }
    }

    return res
  },
  error => {
    hideLoading()
    // 网络错误处理
    console.log('path', error)
    // 根据不同的状态码处理
    if (error.response) {
      switch (error.response.status) {
        case 302:
          console.log('error', error.response)
          break
        case 400:
          Message.error('请求错误')
          break
        case 401:
          Message.error('未授权，请重新登录')
          // 清除 token 并跳转登录
          // localStorage.removeItem('token')
          this.$router.push('/login')
          break
        case 403:
          Message.error('拒绝访问')
          break
        case 404:
          // if (error.response.data.path === '/login') {
          //   router.push('/login')
          // }
          // console.log('error', error.response)
          Message.error('请求地址不存在')
          break
        case 500:
          Message.error('服务器内部错误')
          break
        default:
          Message.error('网络错误')
      }
    } else {
      Message.error('网络连接失败')
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js